const styles = {
    selectButton: {
      marginLeft: 5
    },
    searchFormModalWidth:{
        width: '60%',
        maxWidth: 'none',
      },
  };

export default styles;


// WEBPACK FOOTER //
// ./src/containers/accountSelector/styles/AccountSelectorStyles.js